export const SET_ANALYTICS_PLATFORM_CHANNEL = 'analyticsPlatform/SET_CHANNEL';

export const initialState = {
  channel: null,
};

const analyticsPlatform = (state = initialState, action = {}) => {
  if (action.type === SET_ANALYTICS_PLATFORM_CHANNEL) {
    return {
      ...state,
      channel: action.channel,
    };
  }

  return state;
};

export default analyticsPlatform;
